"use client";

import { createContext, useEffect, useState } from "react";
import Cookies from "js-cookie";

// ============================================================
// AuthContext para manejar autenticación de usuario
// ============================================================

const initialAuth = {
    isAuthenticated: false,
    user: null,
    token: null,
};

export const AuthContext = createContext({
    auth: initialAuth,
    login: (userData) => { },
    logout: async () => { },
});

export default function AuthProvider({ children }) {
    const [auth, setAuth] = useState(initialAuth);

    const login = (userData) => {
        setAuth({
            isAuthenticated: true,
            user: userData.user,
            token: userData.token
        });
        Cookies.set("tokend2g", 'Bearer ' + userData.token);
        window.localStorage.setItem("auth", JSON.stringify({
            isAuthenticated: true,
            user: userData.user,
            token: 'Bearer ' + userData.token,
        }));
    };

    const logout = async () => {
        setAuth(initialAuth);
        window.localStorage.removeItem("auth");
        const cartData = JSON.parse(window.localStorage.getItem("d2gcart"));
        if (cartData) {
            cartData.sessionId = null;
            window.localStorage.setItem("d2gcart", JSON.stringify(cartData));
        }

        Cookies.remove("tokend2g");
    };

    useEffect(() => {
        if (!window) return;
        const storedAuth = window.localStorage.getItem("auth");
        if (storedAuth) {
            setAuth(JSON.parse(storedAuth));
        }
    }, []);

    return (
        <AuthContext.Provider value={{ auth, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}